import React, { createContext, Dispatch } from 'react';
import { Action } from './actions';
import { useAuthData, useEIDData, useUserData } from './hooks';
import { authenticationReducer, AuthenticationState, initialState } from './reducer';

type AuthContext = {
  state: AuthenticationState;
  dispatch: Dispatch<Action>;
  refreshUser: () => void | Promise<void>;
};

const authContext = createContext<AuthContext>({
  state: initialState,
  dispatch: () => null,
  refreshUser: () => {},
});

export const useAuthentication = () => React.useContext<AuthContext>(authContext);
export const AuthenticationProvider: React.FC = ({ children }) => {
  const [state, dispatch] = React.useReducer(authenticationReducer, initialState);

  useAuthData(state, dispatch);
  const { refreshUser } = useUserData(state, dispatch);
  useEIDData(state, dispatch);

  return (
    <authContext.Provider
      value={{
        state,
        dispatch,
        refreshUser,
      }}
    >
      {children}
    </authContext.Provider>
  );
};
